import moment from 'moment/moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Insurances/sales'

export default {
  namespaced: true,
  state: {
    loading: false,
    reportData: {
      data: [],
      grandTotals: {
        sales_count: 0,
        trafik_count: 0,
        kasko_count: 0,
        marka_kasko_count: 0,
        trafik_percent: 0,
        kasko_percent: 0,
        marka_kasko_percent: 0,
      },
      chartData: {
        categories: [],
        series: [],
      },
    },
    salesParams: {
      sdate: `${moment().format('YYYY-MM')}-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
    cumulativesParams: {
      sdate: `${moment().format('YYYY')}-01-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    reportData(state) {
      return state.reportData
    },
    salesParams(state) {
      return state.salesParams
    },
    cumulativesParams(state) {
      return state.cumulativesParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_REPORT_DATA(state, data) {
      state.reportData = data
    },
    /* RESET MUTATIONS */
    RESET_REPORT_DATA(state) {
      state.reportData = {
        data: [],
        grandTotals: {
          sales_count: 0,
          trafik_count: 0,
          kasko_count: 0,
          marka_kasko_count: 0,
          trafik_percent: 0,
          kasko_percent: 0,
          marka_kasko_percent: 0,
        },
        chartData: {
          categories: [],
          series: [],
        },
      }
    },
  },
  actions: {
    getReportData({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_REPORT_DATA')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_REPORT_DATA', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
